// @ts-strict-ignore
import { web } from "@hubble/tokens";
import { Card, Flex, Text, mediaQuery } from "@hubble/web";
import styled from "styled-components";

export const CoinPostsCardContainer = styled.div`
  grid-area: 1 / 3 / 6 / 6;

  @media ${mediaQuery.mobileXsDown} {
    grid-area: 3/ 1 / 5 / -1;
  }
`;

export const CoinPostsCardStyled = styled(Card)`
  height: calc(100% - 40px);
  ul > span:last-child li hr {
    display: none;
  }
` as typeof Card;

export const CoinPostsListItemContentContainer = styled(Flex)`
  align-items: center;
  gap: 12px;
  picture {
    height: 80px;
  }
  img {
    border-radius: 20px;
    border: 1px solid ${web.color.base.gray[100]};
  }
`;

export const CoinPostsListItemTitle = styled(Text.Body)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
`;
